export class Dependency {
  id: number;
  type_name: string;
  number: string;
  size_sqm: number;
  sale_price: number;
  floor: string;
  dependency_type: 'parking' | 'bicycle_parking' | 'storage' | 'garden';
}
